import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SocialProofPopup } from './components/SocialProofPopup';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <LandingPage data-id="element-0" />
      <SocialProofPopup data-id="element-1" />
    </>;
}